/**
 * Thin fetch wrapper for the API. Same-origin `/api` by default: in dev Vite
 * proxies it, in Azure the base URL is injected at build time (M0-16).
 *
 * Deliberately minimal — the typed client generated from the API's OpenAPI
 * spec (M0-25, `@/api/client`) is what new call sites use; this stays only
 * for what hasn't migrated yet.
 */
import { getCurrentAccessToken } from './authToken';

export { setAccessTokenProvider } from './authToken';

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiGet<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  headers.set('Accept', 'application/json');

  const token = await getCurrentAccessToken();
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(`${baseUrl}${path}`, { ...init, headers });

  if (!response.ok) {
    throw new ApiError(`GET ${path} failed`, response.status);
  }

  const contentType = response.headers.get('content-type') ?? '';
  return (contentType.includes('json') ? await response.json() : await response.text()) as T;
}
